(function () {
  var header = document.querySelector('[data-site-header]');
  var toggle = document.querySelector('[data-menu-toggle]');

  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function cleanValue(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function updateQuoteLink(form) {
    var link = form.querySelector('.js-whatsapp-quote');
    if (!link) return;

    var number = link.getAttribute('data-whatsapp') || '';
    var fallback = link.getAttribute('data-default-message') || 'Hi, I need a KLIA taxi quote.';
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-quote-field]'));
    var lines = [fallback, ''];

    fields.forEach(function (field) {
      var value = cleanValue(field.value);
      if (!value) return;
      lines.push(field.getAttribute('data-label') + ': ' + value);
    });

    var message = encodeURIComponent(lines.join('\n'));
    link.href = number ? 'https://wa.me/' + number + '?text=' + message : '#';
  }

  document.querySelectorAll('.js-quote-form').forEach(function (form) {
    var contactEmail = form.querySelector('input[name="contact[email]"][data-contact-email]');
    function ensureContactEmail() {
      if (!contactEmail) return;
      contactEmail.value = contactEmail.getAttribute('data-contact-email') || 'support@kliataxibooking.com';
    }

    ensureContactEmail();
    form.addEventListener('submit', ensureContactEmail);
    updateQuoteLink(form);
    form.addEventListener('input', function () { updateQuoteLink(form); });
    form.addEventListener('change', function () { updateQuoteLink(form); });

    var whatsappLink = form.querySelector('.js-whatsapp-quote');
    if (whatsappLink) {
      whatsappLink.addEventListener('click', function (event) {
        var phoneField = form.querySelector('[data-required-phone]');
        if (!phoneField || phoneField.checkValidity()) return;

        event.preventDefault();
        phoneField.reportValidity();
        phoneField.focus();
      });
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('a[href*="wa.me/"]') : null;
    if (!link || event.defaultPrevented || typeof window.gtag !== 'function') return;

    window.gtag('event', 'conversion', {
      send_to: 'AW-18402323656/nVpJCOSJruUcEMjZ9MZE',
      value: 1.0,
      currency: 'MYR'
    });
  });
})();


